import type { Ref } from '@vue/composition-api';
import { computed } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { useActiveDealTimes } from './active-deal-times.composable';

export const useActiveDealTimesData = (showAll: Ref<boolean>) => {
  const previousPeriod = {
    from: DateTime.now().toUTC().minus({ month: 1 }).startOf('month').toMillis(),
    to: DateTime.now().toUTC().minus({ month: 1 }).endOf('month').toMillis(),
  };
  const currentPeriod = {
    from: DateTime.now().toUTC().startOf('month').toMillis(),
    to: DateTime.now().toUTC().endOf('month').toMillis(),
  };

  const {
    isLoading: previousPeriodLoading,
    isSuccess: previousPeriodSuccess,
    data: previousData,
  } = useActiveDealTimes(previousPeriod, showAll);
  const {
    isLoading: currentPeriodLoading,
    isSuccess: currentPeriodSuccess,
    data: currentData,
  } = useActiveDealTimes(currentPeriod, showAll);

  return {
    isLoading: computed(() => previousPeriodLoading.value || currentPeriodLoading.value),
    isSuccess: computed(() => previousPeriodSuccess.value && currentPeriodSuccess.value),
    previousData,
    currentData,
  };
};
